import './scss/main.scss';

require('intersection-observer')
import isTouchDevice from 'is-touch-device'
import { initHomeHeader } from './js/homeHeader.js'
import { initQandA } from './js/QandA.js'
import { initHiddentext } from './js/Hiddentext.js'
import { initScrollto } from './js/scrollTo.js'
import { initVideoPopup } from './js/videoPopup.js'
import { initHeader } from './js/header.js'
import { initCountUp } from './js/countUp.js'
import LazyLoad from 'vanilla-lazyload'

export const isTouch = isTouchDevice()

const initApp = function () {
  initHomeHeader()
  initQandA()
  initHiddentext()
  initScrollto()
  initVideoPopup()
  initHeader()
  initCountUp()

  var myLazyLoad = new LazyLoad({ elements_selector: '.lazy' })

  const loadingScreen = document.querySelector('#loading-screen')
  if (loadingScreen)
    setTimeout(() => { loadingScreen.classList.add('hide') }, 150)
}

initApp()
